<template>
  <v-layout>
    <v-flex>
      <panel :title="company.name">
        <v-text-field
          :label="$t('companyGenerics.companyId')"
          disabled
          :rules="[required]"
          v-model="company.company_id"
        ></v-text-field>

        <v-text-field
          :label="$t('companyGenerics.companyName')"
          required
          :rules="[required]"
          v-model="company.company_name"
        ></v-text-field>

        <v-text-field
          :label="$t('companyGenerics.companyDescr')"
          required
          :rules="[required]"
          v-model="company.description"
        ></v-text-field>

        <v-switch
          :label="$t('companyDetails.enabled')"
          v-model="company.enabled"
        ></v-switch>

        <v-text-field
          :label="$t('companyDetails.uniqueId')"
          readonly
          v-model="company.unique_id"
        ></v-text-field>

        <div class="danger-alert" v-if="error">
          {{ error }}
        </div>

        <v-btn dark class="secondary" @click="save">
          {{ $t("companyDetails.saveCompany") }}
        </v-btn>
      </panel>
    </v-flex>
  </v-layout>
</template>

<script>
import CompaniesService from "@/services/CompaniesService";

export default {
  props: ["clickedId"],
  data() {
    return {
      company: {
        companyID: null,
        name: null,
        description: null,
        enabled: null
      },
      error: null,
      required: value => !!value || value === 0 || "Required."
    };
  },
  methods: {
    async save() {
      this.error = null;
      try {
        // Force bool since it can be null and its integer in db model
        this.company.enabled = this.company.enabled ? true : false;
        await CompaniesService.put(this.company);
        this.$emit("close");
      } catch (err) {
        this.error = err.response.statusText;
        console.log(err);
      }
    }
  },
  watch: {
    clickedId: async function() {
      this.error = null;
      try {
        const companyID = this.clickedId;
        this.company = (await CompaniesService.get(companyID)).data;
      } catch (err) {
        console.log(err);
        this.error = err.response.statusText;
      }
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/EditCompany.vue